var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProjectManagementColored2 = function SvgProjectManagementColored2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.403 17.439H8.258A1.265 1.265 0 0 1 7 16.176V6.628a1.256 1.256 0 0 1 1.258-1.262h11.32c.335 0 .654.132.89.369s.369.558.369.893V9.21M7.33 9.184h10.377"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M10.657 4.809v1.358M17.982 4.75v1.358"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 15,
    y: 14,
    stroke: "#000",
    strokeWidth: 1.5,
    rx: 0.804
  })));
};
export default SvgProjectManagementColored2;